const initialState = {
  loguedUser: [],
  isAuthenticated: false,
  isAuthenticating: false,
};
const rootReducer = (state = initialState, action) => state;
export default rootReducer;
